// Template8Pdf.jsx (Template9Pdf.jsx and Template10Pdf.jsx are copies with SIDEBAR_COLOR changed)
import React from 'react';
import { Document, Page, View, Text, StyleSheet } from '@react-pdf/renderer';
import {
    ContactSection, BadgeListSection, SocialSection,
    AboutSection, ExperienceSection, EducationSection, ReferencesSection,
} from './PdfSections';

const SIDEBAR_COLOR = '#B44949'; // Template9: same '#B44949' maroon; Template10: same '#004C7D'
const HEADING = '#002640';

const styles = StyleSheet.create({
    page: { flexDirection: 'row', padding: 0, fontSize: 10, fontFamily: 'Helvetica' },
    left: { width: '65%', padding: 20 },
    right: { width: '35%', backgroundColor: SIDEBAR_COLOR, padding: 20, color: '#ffffff' },
    name: { fontSize: 18, fontWeight: 'bold', marginBottom: 4 },
    title: { fontSize: 11, marginBottom: 12 },
});

function Template8Pdf(props) {
    const {
        name, about, email, address, phone, title,
        technicalSkills, languages, softSkills,
        linkedinURL, twitterURL, githubURL, websiteURL,
        educationData, jobData, showSocial, referenceData,
    } = props;

    return (
        <Document>
            <Page size="A4" style={styles.page} wrap>
                <View style={styles.left}>
                    <Text style={styles.name}>{name}</Text>
                    <AboutSection about={about} headingColor={HEADING} />
                    <ExperienceSection jobData={jobData} headingColor={HEADING} />
                    <EducationSection educationData={educationData} headingColor={HEADING} />
                    <ReferencesSection referenceData={referenceData} headingColor={HEADING} />
                </View>
                <View style={styles.right}>
                    <Text style={styles.title}>{title}</Text>
                    <ContactSection email={email} phone={phone} address={address} />
                    <BadgeListSection title="Professional Skills" items={technicalSkills} />
                    <BadgeListSection title="Soft Skills" items={softSkills} />
                    <BadgeListSection title="Languages Known" items={languages} />
                    <SocialSection linkedinURL={linkedinURL} twitterURL={twitterURL} githubURL={githubURL} websiteURL={websiteURL} showSocial={showSocial} />
                </View>
            </Page>
        </Document>
    );
}

export default Template8Pdf;